(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nene-brand-film"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('nene-brand-video')){
 customElements.define('nene-brand-video',class extends HTMLElement{
  connectedCallback(){
   if(this.controller)return;this.controller=new AbortController();const options={signal:this.controller.signal};
   this.video=this.querySelector('video');this.playButton=this.querySelector('button');this.playButton.hidden=false;this.video.controls=false;
   this.playButton.addEventListener('click',()=>{if(!this.video.src)this.video.src=this.video.dataset.filmSrc;this.video.controls=true;this.playButton.hidden=true;this.video.play().catch(()=>{this.playButton.hidden=false;});},options);
   this.video.addEventListener('ended',()=>{this.playButton.hidden=false;},options);
   document.addEventListener('visibilitychange',()=>{if(document.hidden)this.video.pause();},options);
   this.observer=new IntersectionObserver(entries=>{if(!entries[0].isIntersecting)this.video.pause();});this.observer.observe(this);
  }
  disconnectedCallback(){this.video?.pause();this.controller?.abort();this.observer?.disconnect();this.controller=null;}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nene-connect"] && !Shopify.designMode) return;
  try {
    
  function initNeneConnect(scope) {
    scope.querySelectorAll('[data-nene-connect]').forEach(function(root) {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      root.querySelectorAll('[data-nene-topic]').forEach(function(link) {
        link.addEventListener('click', function() {
          var select = root.querySelector('[data-nene-topic-select]');
          if (select) select.value = link.dataset.neneTopic;
        });
      });
      var result = root.querySelector('[data-nene-result]');
      if (result) result.focus();
    });
  }
  initNeneConnect(document);
  document.addEventListener('shopify:section:load', function(event) { initNeneConnect(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nene-social"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nene-instagram-feed')) {
  customElements.define('nene-instagram-feed', class extends HTMLElement {
    connectedCallback() {
      const content = this.querySelector('[data-instagram-content]');
      if (!content) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const controls = this.querySelector('[data-feed-controls]');
      const navigation = this.querySelector('[data-feed-navigation]');
      const previous = this.querySelector('[data-feed-prev]');
      const next = this.querySelector('[data-feed-next]');
      const motionButton = this.querySelector('[data-feed-motion]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.videoPaused = this.motion.matches;
      const videos = () => Array.from(content.querySelectorAll('video.auto-loop-videos'));
      const updateNavigation = () => {
        if (!this.rail) return;
        const canScroll = this.rail.scrollWidth > this.rail.clientWidth + 2;
        navigation.hidden = !canScroll;
        previous.disabled = this.rail.scrollLeft <= 2;
        next.disabled = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 2;
        controls.hidden = !canScroll && motionButton.hidden;
      };
      const updateMotion = () => {
        motionButton.hidden = videos().length === 0;
        motionButton.textContent = this.videoPaused ? motionButton.dataset.playLabel : motionButton.dataset.pauseLabel;
      };
      const move = direction => {
        if (!this.rail) return;
        const item = this.rail.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
        const width = item ? item.getBoundingClientRect().width + gap : this.rail.clientWidth;
        this.rail.scrollBy({ left: direction * width, behavior: this.motion.matches ? 'instant' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      content.addEventListener('play', event => {
        if (this.videoPaused && event.target.matches('video.auto-loop-videos')) event.target.pause();
      }, { ...options, capture: true });
      motionButton.addEventListener('click', () => {
        this.videoPaused = !this.videoPaused;
        videos().forEach(video => {
          if (this.videoPaused) video.pause();
          else {
            const rect = video.getBoundingClientRect();
            const railRect = this.rail?.getBoundingClientRect();
            if (rect.bottom > 0 && rect.top < window.innerHeight && rect.right > (railRect?.left || 0) && rect.left < (railRect?.right || window.innerWidth)) video.play().catch(() => {});
          }
        });
        updateMotion();
      }, options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) { this.videoPaused = true; videos().forEach(video => video.pause()); updateMotion(); }
      }, options);
      const update = () => {
        const hasMedia = Boolean(content.querySelector('img[src],video[src],video[poster],video source[src],iframe[src]'));
        this.toggleAttribute('data-feed-empty', !hasMedia);
        const rail = content.querySelector('.instafeed-new-layout-container[data-layout="6"] > .instafeed-new-layout-wrapper');
        if (rail !== this.rail) {
          this.railResize?.disconnect();
          this.rail = rail;
          if (rail) {
            rail.addEventListener('scroll', updateNavigation, { ...options, passive: true });
            this.railResize = new ResizeObserver(updateNavigation);
            this.railResize.observe(rail);
          }
        }
        updateMotion();
        updateNavigation();
        if (this.videoPaused) videos().forEach(video => video.pause());
      };
      this.feedObserver = new MutationObserver(update);
      this.feedObserver.observe(content, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'poster'] });
      update();
    }
    disconnectedCallback() { this.feedObserver?.disconnect(); this.railResize?.disconnect(); this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nene-story-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nene-story-slider')) {
  customElements.define('nene-story-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = Array.from(this.querySelectorAll('[data-story]'));
      this.tabs = Array.from(this.querySelectorAll('[data-story-select]'));
      this.toggle = this.querySelector('[data-story-toggle]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.dataset.autoplay !== 'true' || this.motion.matches || Boolean(window.Shopify?.designMode);
      this.interval = Math.max(5000, Number(this.dataset.interval) || 6500);
      this.inViewport = false;
      this.index = 0;
      if (!this.slides.length) return;
      const controls = this.querySelector('.nene-stories__controls');
      if (controls) controls.hidden = false;
      this.tabs.forEach((button, index) => {
        button.addEventListener('click', () => this.show(index), options);
        button.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowLeft') next = this.index - 1;
          if (event.key === 'ArrowRight') next = this.index + 1;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.slides.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.show(next);
          this.tabs[this.index].focus();
        }, options);
      });
      this.toggle?.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.schedule();
      }, options);
      this.addEventListener('focusin', event => {
        if (this.toggle?.contains(event.target)) return;
        this.userPaused = true;
        this.schedule();
      }, options);
      this.motion.addEventListener('change', event => {
        if (event.matches) this.userPaused = true;
        this.schedule();
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.observer = new IntersectionObserver(entries => {
        this.inViewport = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      this.querySelectorAll('.nene-hero-story__media').forEach(media => {
        media.addEventListener('pointerdown', event => {
          if (event.pointerType === 'mouse') return;
          clearTimeout(this.timer);
          this.touchStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
        }, options);
        media.addEventListener('pointerup', event => {
          if (!this.touchStart || this.touchStart.id !== event.pointerId) return;
          const dx = event.clientX - this.touchStart.x;
          const dy = event.clientY - this.touchStart.y;
          this.touchStart = null;
          if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1));
          else this.schedule();
        }, options);
        media.addEventListener('pointercancel', () => { this.touchStart = null; this.schedule(); }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        this.userPaused = true;
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.show(index);
      }, options);
      this.show(0);
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.toggle) {
        const label = this.userPaused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
        this.toggle.setAttribute('aria-label', label);
        this.toggle.querySelector('[data-story-toggle-text]').textContent = label;
        this.toggle.querySelector('[data-story-pause-icon]').toggleAttribute('hidden', this.userPaused);
        this.toggle.querySelector('[data-story-play-icon]').toggleAttribute('hidden', !this.userPaused);
      }
      if (this.slides.length < 2 || this.userPaused || !this.inViewport || document.hidden || this.touchStart) return;
      this.timer = setTimeout(() => this.show(this.index + 1), this.interval);
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.inert = i !== this.index;
        slide.setAttribute('aria-hidden', String(i !== this.index));
      });
      this.tabs.forEach((button, i) => {
        button.setAttribute('aria-selected', String(i === this.index));
        button.tabIndex = i === this.index ? 0 : -1;
      });
      const active = this.slides[this.index];
      this.style.setProperty('--current-story-bg', active.style.getPropertyValue('--story-bg'));
      this.style.setProperty('--current-story-ratio', active.style.getPropertyValue('--story-ratio'));
      const nextImage = this.slides[(this.index + 1) % this.slides.length].querySelector('img');
      if (nextImage) nextImage.loading = 'eager';
      this.schedule();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
